import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Card, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  updatepackageCategory,
  getpackageCategory,
} from "../../store/slices/packagecategory";
import { useParams } from "react-router-dom";

export default function EditCategory() {
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialForm = {
    name: "",
  };
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchcategory = async () => {
      try {
        let item = { id };
        const res = await dispatch(getpackageCategory(item)).unwrap();

        const category = res?.packageCategory[0];

        if (category) {
          setForm({ name: category.name || "" });
        }
      } catch (err) {
        toast.error("Failed to fetch category details");
      }
    };

    if (id) fetchcategory();
  }, [dispatch, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => {
      const newErrors = { ...prev };

      switch (name) {
        case "name":
          if (!value.trim()) newErrors.name = "Please enter hotel name";
          else delete newErrors.name;
          break;

        default:
          break;
      }

      return newErrors;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!form.name.trim()) newErrors.name = "Please enter category name";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      setLoading(true);

      const payload = {
        id,
        name: form.name.trim(),
      };

      await dispatch(updatepackageCategory(payload)).unwrap();

      toast.success("Category edited successfully");

      setForm(initialForm);
      setErrors({});

      navigate("/admin/category");
    } catch (err) {
      toast.error(
        err?.response?.data?.message ||
        err?.message ||
        "Failed to edit category",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>
          <Link to="/admin/category" className="breadcrumb-link active">
            Categeory
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive">Edit Category</span>
        </div>
      </div>

      <Container fluid className="p-4">
        <Card style={{ border: "none" }}>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row className="mb-4">
                <Col md={6}>
                  <Form.Label>Category Name</Form.Label>
                  <Form.Control
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Enter category name"
                  />

                  {errors.name && (
                    <div className="text-danger small mt-1">{errors.name}</div>
                  )}
                </Col>
              </Row>

              <div className="d-flex justify-content-center gap-3">
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        variant="light"
                        className="me-2"
                      />
                      Updating...
                    </>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
